<div *ngIf="isLoading">Loading Letterhead List...</div>

<select *ngIf="!isLoading && model && model !== undefined" [compareWith]="byId" class="form-control" name="letterhead" [(ngModel)]="model.letterhead" [required]="required">
  <option *ngFor="let singleLetterhead of letterheads" [ngValue]="singleLetterhead">{{ singleLetterhead.name }}</option>
</select>

<select *ngIf="!isLoading && (!model || model === undefined)" [compareWith]="byId" class="form-control" name="letterhead" ngModel [required]="required">
  <option *ngFor="let singleLetterhead of letterheads" [ngValue]="singleLetterhead">{{ singleLetterhead.name }}</option>
</select>
